<div fxLayout="row" class="scroll-icons">
    <fa-icon class="scroll-icon" [icon]="faAnglesUp" (click)="scrollUpDown(false);"></fa-icon>
    <fa-icon class="scroll-icon" [icon]="faAnglesDown" (click)="scrollUpDown(true);"></fa-icon>    
</div>
